import { graphql } from '../../../../graphql/generated';

export const CREATE_FORM_MUTATION = graphql(`
  mutation CreateForm($input: FormInput!) {
    createForm(input: $input) {
      id
    }
  }
`);
